import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "bootstrap"; //important dont delete//
import "../MyInvitations/Events.css";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../Context/store/context";
import globals from "../../../globals";
import { IconChevronDown, IconX, IconSearch } from '@tabler/icons-react'
import { _get } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";
import DemoCard from "./Demo-Card";
import Pagination from "../../Layout/Pagination";
import Icon from '@mdi/react';
import { mdiSort } from '@mdi/js';
import config from "../../../config";

export default function MyDemos() {
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const [demos, setDemos] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("-creationdate");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.mydemos.title, globals.mydemos.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      fetchInvitationDetails();
    }
  }, [userDetails, currentPage, sortBy, searchTerm]);

  const fetchInvitationDetails = async () => {
    showLoader();
    await _get(`/events?page=${currentPage}&pageSize=18&sortBy=${sortBy}&searchTerm=${searchTerm}&filterBy=all&isForDemo=true`)
      .then((response) => {
        setDemos(response.records);
        setCurrentPage(response.currentPage);
        setTotalPages(response.pageCount);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }

  const paginationHandler = (from) => {
    if (from == "previous" && (currentPage - 1) >= 0) {
      setCurrentPage(currentPage - 1);
    }
    else if (from == "next" && (currentPage + 1) <= totalPages) {
      setCurrentPage(currentPage + 1);
    }
  }

  const sortHandler = (sort) => {
    if (sortBy != sort) {
      setSortBy(sort);
      setCurrentPage(0);
    }
  }

  const searchHandler = () => {
    setSearchTerm(searchValue);
    setCurrentPage(0);
  }

  const resetHandler = () => {
    setSearchTerm("");
    setSearchValue("");
    setCurrentPage(0);
  }

  return (
    <>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 pt-3">
          <div className="card mb-3 ">
            <div className="card-body d-flex align-items-center flex-wrap">
              <div className="flex-grow-1 d-flex flex-wrap">
                <div className="flex-grow-1 flex-shrink-0 search me-1">
                  <div className="search-input-wrap w-100 md-w-75">
                    <input className="search-input w-100 p-2" placeholder="Search by demo name" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                    {searchValue && searchValue != "" &&
                      <IconX size={16} className="search-clear" onClick={resetHandler} />
                    }
                  </div>
                  <button className="btn btn-soft-primary search-btn me-1" onClick={searchHandler}><IconSearch size={16} /></button>
                </div>
                <div className="ms-1 ms-md-5">
                  <div className="dropdown" data-bs-toggle="dropdown">
                    <div aria-haspopup="true" className="" aria-expanded="false" style={{ width: "max-content" }}>
                      <button className="btn btn-outline-primary py-0 me-0 me-md-2 py-md-2 d-flex">
                        <Icon path={mdiSort} className="d-block d-md-none" style={{ width: "1.5rem", height: "2rem" }} />
                        <div className="d-none d-md-block">Sort By</div>
                        <IconChevronDown size={18} className="d-none d-md-block" />
                      </button>
                    </div>
                    <div role="menu" aria-hidden="true" className="px-1 px-md-3 dropdown-menu">
                      <b>Creation Time</b>
                      <button type="button" role="menuitem" className={"dropdown-item " + (sortBy == "creationdate" ? "active" : "")}
                        onClick={() => sortHandler("creationdate")}>Old-New</button>
                      <button type="button" role="menuitem" className={"dropdown-item " + (sortBy == "-creationdate" ? "active" : "")}
                        onClick={() => sortHandler("-creationdate")}>New-Old</button>
                      <hr /><b>Demo Name</b>
                      <button type="button" role="menuitem" className={"dropdown-item " + (sortBy == "title" ? "active" : "")}
                        onClick={() => sortHandler("title")}>A-Z</button>
                      <button type="button" role="menuitem" className={"dropdown-item " + (sortBy == "-title" ? "active" : "")}
                        onClick={() => sortHandler("-title")}>Z-A</button>
                    </div>
                  </div>
                </div>
              </div>
              <NavLink to="/create-demo/themes" className="btn btn-primary px-4 m-2 d-none d-md-block">
                Create Demo
              </NavLink>
            </div>
          </div>
          {(!demos || (demos && demos.length == 0)) && (
            <div className="card">
              <div className="card-body mb-5">
                <div className=" d-flex flex-column align-items-center justify-content-center">
                  <div className="mt-4">
                    <img
                      src="/images/no-events-found.jpg"
                      alt="No Demos Found"
                      id="noeventsimg"
                    />
                  </div>
                  <h4 className="mt-4">
                    You dont have any demos <br /> Start by creating new demo</h4><div>
                    <NavLink to="/create-demo/themes" className="mt-3 btn btn-primary btn-glow" >
                      Create New Demo
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          )}

          {demos && demos.length > 0 && (
            <>
              <div className="row g-3 mb-3">
                {demos.map((demo, index) => {
                  return <DemoCard data={demo} key={demo.id} refreshData={fetchInvitationDetails} />
                })
                }
              </div>
              <Pagination currentPage={currentPage} totalPages={totalPages}
                pagination={paginationHandler} />
            </>
          )}
        </div>
      </div>
    </>
  );
}
